module.exports = __webpack_public_path__ + "static/images/cover_B2.0c87657.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover/cover_B2.png
// module id = 2FCs
// module chunks = 8